import * as React from 'react';

// tslint:disable:max-line-length
export const ConciergeIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
    <path
      fillRule="nonzero"
      d="M16 8.8l-2-8c-.1-.5-.5-.8-1-.8h-3v2h2.2l1.5 6H2.3l1.5-6H6V0H3c-.5 0-.9.3-1 .8l-2 8V12c0 2.2 1.8 4 4 4s4-1.8 4-4c0 2.2 1.8 4 4 4s4-1.8 4-4V9v-.2zM6 12c0 1.1-.9 2-2 2s-2-.9-2-2v-2h4v2zm8 0c0 1.1-.9 2-2 2s-2-.9-2-2v-2h4v2z"
    />
  </svg>
);
